import React from 'react';
import {useRecoilValue} from 'recoil';

import {timerState} from './atom';

const Timer = () => {
    const timer = useRecoilValue(timerState);

    return (
        <div className="timer">
            <p>Vreme: <span className='number'>{`${(typeof timer === "number") ? Math.abs(timer).toFixed(0) : 0}`}</span> sec</p>

        </div>
    );
};

export default React.memo(Timer);
